import React from "react";
import "./Footer.css";
import googleStore from "../../../images/phone/google_play_store.png";
import appleStore from "../../../images/phone/apple_play_store.png";

const FooterTop = () => {
  return (
    <div>
      <div className="container py-5">
        <div className="row mx-auto w-100">
          <div className="col-7 col-md-3 p-0">
            <div className="footer_top_title">
              <p>
                <span>New</span> Categories
              </p>
            </div>
            <div className="footer_top_sub text-secondary">
              <p className="text-secondary mb-0">Film Equipment</p>
              <p className="text-secondary mb-0">Drones</p>
              <p className="mb-0">Warehouse</p>
              <p className="text-secondary mb-0">Parking</p>
              <p className="mb-0">Boats</p>
              <p className="text-secondary mb-0">Yatchs</p>
              <p className="text-secondary mb-0">Sporting Equuipment</p>
            </div>
          </div>
          <div className="col-5 col-md-3 p-0">
            <div className="footer_top_title">
              <p>
                <span>Popular</span> Stays
              </p>
            </div>
            <div className="footer_top_sub">
              <p className="text-secondary mb-0">Apartment</p>
              <p className="text-secondary mb-0">Villa</p>
              <p className="text-secondary mb-0">Holet</p>
              <p className="text-secondary mb-0">Resort</p>
              <p className="text-secondary mb-0">Loft</p>
              <p className="text-secondary mb-0">LightHouse</p>
              <p className="text-secondary mb-0">Cottage</p>
            </div>
          </div>
          <div className="col-7 col-md-3 padding-top px-0">
            <div className="footer_top_title">
              <p>
                <span>Popular</span> Location
              </p>
            </div>
            <div className="footer_top_sub">
              <p className="text-secondary mb-0">Dubai</p>
              <p className="text-secondary mb-0">New York</p>
              <p className="text-secondary mb-0">London</p>
              <p className="text-secondary mb-0">Paris</p>
              <p className="text-secondary mb-0">Tel Aviv</p>
              <p className="text-secondary mb-0">Cairo</p>
              <p className="text-secondary mb-0">California</p>
            </div>
          </div>
          <div className="col-5 col-md-3 padding-top px-0">
            <div className="footer_top_title">
              <p>
                <span>Join</span> WeShare
              </p>
            </div>
            <div className="footer_top_sub">
              <p className="text-secondary mb-0 p-0">List an Item</p>
              <p className="text-secondary mb-0">How it works</p>
              <p className="text-secondary mb-0 ">Login/SignUp</p>
              <div>
                <img
                  src={googleStore}
                  alt=""
                  className="mt-2 play_store_footer"
                />
                <br />
                <img src={appleStore} alt="" className="mt-3 footer_apple" />
              </div>
            </div>
          </div>
        </div>
        <hr className="hr" />
      </div>
    </div>
  );
};

export default FooterTop;
